import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

const icons = ['AddHW', 'ArrowDown', 'Calibration', 'CaretDown', 'CaretUp', 'Create', 'Delete', 'Edit', 'EditOff', 'Firmware', 'Home', 'HoofBoots', 'Loading', 'Logout', 'Measurement', 'Rider', 'Search', 'Update', 'Upload', 'User', 'Vets'];

@Injectable()
export class IconService {
    constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
        this.registerIcons();
    }
    private registerIcons() {
        icons.forEach(name => {
            this.matIconRegistry.addSvgIcon(name, this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${name}.svg`));
        });
    }
}